import React, { useState, useEffect } from "react";
import Banner from "../components/ListOfOrganizer/ListOfOrganizerNew/Banner";
import MainOrganizer from "../components/ListOfOrganizer/ListOfOrganizerNew/MainOrganizer";

import Layout from "../layout/Main";
import { http } from "../misc/http";

export default function NewListOfOrganizer() {
  const [organizer, setOrganizer] = useState([]);
  const [categories, setCategories] = useState([]);

  const saveResponse = (data, setData) => {
    setData(data.data);
  };

  useEffect(() => {
    handleGetAll(`organizer`, setOrganizer);
    handleGetAll(`organizer/category/findAll`, setCategories);
  }, []);

  const handleGetAll = async (path, stateName) => {
    let params = {
      method: "GET",
      path: path,
      showMessage: false,
    };
    let { data } = await http(params);
    if (data.status === true && data.code === 200) {
      saveResponse(data, stateName);
    }
  };

  return (
    <Layout>
      <Banner />
      <MainOrganizer
        organizer={organizer}
        categories={
          categories
            ? categories.map((e) => ({
                value: e.categoryName,
                label: e.categoryName,
              }))
            : []
        }
      />
    </Layout>
  );
}
